import { RequestHandler } from 'express';
import RolesMigrationService from '~/services/RolesMigrationService';
import mapAppErrorToObject from '~/transformations/mapAppErrorToObject';
import { saveRecorded } from '../mockingMiddleware';

export const getRoles: RequestHandler = async (req, res) => {
  try {
    const service = new RolesMigrationService(
      res.locals.payload,
      res.locals.preview
    );

    await service.GetRoles();
    const response = service.MapGetRolesResponse();

    res.send(response);
    saveRecorded(req, res, {
      operation: 'getRoles',
      response,
    });
  } catch (error: any) {
    res.status(500).send({ error: mapAppErrorToObject(error) });
  }
};
